export const MainFilterHandler = (pageDetail, talentType) => {
    let filter = [];
    if (pageDetail?.page) {
        filter.push(`page=${pageDetail?.page}&limit=${pageDetail?.limit}`);
    }
    if (pageDetail?.searchQuery) {
        filter.push(`search=${pageDetail?.searchQuery}`);
    }
    if (pageDetail?.isBanner) {
        filter.push("isBannerPublished=true")
    }
    let filterData = filter.join("&");
    return filterData;
};
